module.exports = __webpack_public_path__ + "static/img/teams.b6422bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teams.jpg
// module id = 101
// module chunks = 1